import { ItfSceneProductCardInput } from '@elem/compCommon/SceneProducts/type';

/** Cost Saving AU — 太阳能板产品卡片 */
export const COST_SAVING_AU_SCENE_PRODUCTS: ItfSceneProductCardInput[] = [
    {
        link_more: 'https://au.ecoflow.com/products/ecoflow-delta-3-max-plus-portable-power-station',
        productId: '8780161286342',
        variantId: '45556169801926',
        title: 'DELTA 3 Max Plus Solar Generator (PV400W)',
        descArr: ['2-10kWh Capacity I 3000W Output', 'Solar Ready in 1.h Hrs'],
    },
    {
        link_more: 'https://au.ecoflow.com/products/ecoflow-delta-pro-3-portable-power-station?variant=44062870601926',
        productId: '8311879925958',
        variantId: '44062870601926',
        title: 'DELTA Pro 3 Solar Generator (PV 400W)',
        descArr: ['4–12kWh Capacity(333Ah@12V)', '4000W Output', 'Solar-ready in 12 hrs'],
    },
];

export const COST_SAVING_AU_SCENE_PRODUCTS_MORE: ItfSceneProductCardInput[] = [
    {
        link_more:
            'https://energy.ecoflow.com/au/products/ocean-2-plus-single-phase-home-battery?utm_source=efweb&utm_medium=link&utm_campaign=energy_saving_webpage',

        title: 'EcoFlow OCEAN 2 Plus Single-Phase',
        descArr: ['96kWh Capacity', '12kW Output Power'],
        img: 'https://websiteoss.ecoflow.com/upload/image/1786437508071/20260811-163629.png',
    },
    {
        link_more: 'https://energy.ecoflow.com/au/products/ocean-2-home-battery?utm_source=efweb&utm_medium=link&utm_campaign=energy_saving_webpage',
        // productId: '8311879925958',
        // variantId: '44062870601926',
        title: 'EcoFlow OCEAN 2 Three-Phase',
        descArr: ['96kWh Capacity', '12kW Output Power'],
        img: 'https://websiteoss.ecoflow.com/upload/image/1786437508071/20260811-163629.png',
    },
    {
        link_more: 'https://energy.ecoflow.com/au/products/powerocean-single-phase?utm_source=efweb&utm_medium=link&utm_campaign=energy_saving_webpage',
        // productId: '8311879925958',
        // variantId: '44062870601926',
        title: 'EcoFlow PowerOcean Single-Phase',
        descArr: ['40kWh Capacity', '6kW Output Power'],
        img: 'https://websiteoss.ecoflow.com/upload/image/1786437489300/20260811-163636.png',
    },
];
